export { default as PaymentsStripe } from './Stripe';
